import { render, staticRenderFns } from "./contractor.vue?vue&type=template&id=478f77a2&scoped=true&"
import script from "./contractor.vue?vue&type=script&lang=js&"
export * from "./contractor.vue?vue&type=script&lang=js&"
import style0 from "./contractor.vue?vue&type=style&index=0&id=478f77a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478f77a2",
  null
  
)

component.options.__file = "contractor.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VLayout,
})
